import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1dd44e2"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b1dd44e2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports